export default __webpack_public_path__ + "static/media/project4.d28dc739.png";